var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tree',_vm._g(_vm._b({ref:"tree",attrs:{"current-node-key":_vm.currentKey,"default-expanded-keys":_vm.expandedKeys},on:{"node-click":_vm.currentChange,"node-expand":_vm.nodeExpand,"node-collapse":_vm.nodeCollapse},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('div',{},[_vm._t("default",null,{"node":node,"data":data})],2)}}],null,true)},'el-tree',_vm.Props,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }